import { render, staticRenderFns } from "./PromoCode.vue?vue&type=template&id=85c38e54"
import script from "./PromoCode.vue?vue&type=script&lang=js"
export * from "./PromoCode.vue?vue&type=script&lang=js"
import style0 from "./PromoCode.vue?vue&type=style&index=0&id=85c38e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports